import { Component, OnInit, Input } from '@angular/core';
import { Retencion } from '../../../models/retencion';
import { RetencionService } from '../../../services/retencion.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as numeral from 'numeral';

@Component({
	selector: 'retencion-modal',
	templateUrl: './retencion-modal.component.html',
    styleUrls: ['./retencion-modal.component.css'],
    providers: [RetencionService]
})
export class RetencionModalComponent implements OnInit {
    @Input() retencion_id: String;
    @Input() numero_decimales: number = 2;
    public retencion: Retencion;
    public total: number;
    public loading = false;
    public format_decimal: String;

    constructor(
        private retencionService: RetencionService,
        public bsModalRef: BsModalRef,
    ){
        this.retencion = new Retencion();
        this.total = 0;
        this.format_decimal = "0,0.00";
    }

    ngOnInit(){
        let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
        this.format_decimal = "0,0." + digitos
        
        this.getRetencionById();
    }

    getRetencionById(){
        this.loading = true;
        let qs = "?embed=detalle?embed=impuesto,venta?embed=tipocomprobante;bodega;cliente";
        this.retencionService.getById(this.retencion_id, qs).subscribe(
            res => {
                this.loading = false;
                this.retencion = res;
                this.total = 0;
                this.retencion.detalle.forEach(x => this.total += parseFloat(x.total.toString()));
            },
            err => {
                this.loading = false;
            }
        );
    }

    getNumeroDocumento(retencion){
		return retencion.serie + "-" + retencion.punto_emision + "-" + retencion.secuencial;
    }
    
    getSubtotal(venta){
        if(venta){
            let n = parseFloat(venta.subtotal_iva12) + parseFloat(venta.subtotal_iva0);
		    return numeral(n).format(this.format_decimal);
        }
    }
    
    get formatDecimal(){
        return this.format_decimal;
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/retencion-modal/retencion-modal.component.ts